import { NgModule } from '@angular/core';
import { S121gS121m01Component } from './s121g-s121m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S121gS121m01Component]
})
export class S121gModule { }

